import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
} from "./../../components/card/card.jsx";
import DataTable from "react-data-table-component";
import {
  generateLocationToArray,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { useAuth } from "../../contexts/AuthContext";
import { dataProcess } from "../../api";
import { parserAPI } from "../../utils/parser.jsx";
import { useNavigate } from "react-router-dom";
import { dateToToday } from "../../utils/helper";
import { Spinner } from "react-bootstrap";
import { Loader } from "../../utils/helper";

import ImageViewer from "../../components/ImageViewer";
import { LocationFilter } from "../../components/LocationFilter";
import { useLocation } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import MachineHealth from "../analytics/machine_health.js";
import MachineList from "../machine/list.js";
import MachineHierarchy from "../machine/hierarchy.jsx";
import MachineComparison from "../machine-comparison";
import { useSearchParams } from "react-router-dom";


function MachineMonitoring() {
  let dataLocation = useLocation();
  const [key, setKey] = useState("tab0");
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTab = searchParams.get("tab");
  const { config, email } = useAuth();

  useEffect(() => {
    if (selectedTab) {
      setKey('tab' + selectedTab);
    }
  }, [selectedTab]);


  const handleTabChange = (tab) => {
    setKey(tab);
    setSearchParams({ tab: tab.replace("tab", "") });
  }


  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#/">MACHINE</a>
                </li>
                <li className="breadcrumb-item active">MACHINE MONITORING</li>
              </ul>


              <hr className="mb-4" />

              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => handleTabChange(k)}
                className="mb-3 fw-bold"
              >
                {['Machine Health', 'Machine List', 'Machine Comparison', 'Machine Hierarchy'].filter((item, index) => {
                  if (email === 'admin_cp@groundup.ai' && index === 3) {
                    return false;
                  }
                  return true;
                }).map((item, index) => {
                  return (
                    <Tab
                      eventKey={"tab" + index}
                      title={item}
                    >

                      {key == 'tab0' && (
                        <MachineHealth />
                      )}
                      {key == 'tab1' && (
                        <MachineList />
                      )}
                      {key == 'tab2' && (
                        <MachineComparison />
                      )}
                      {key == 'tab3' && (
                        <MachineHierarchy />
                      )}
                    </Tab>
                  );
                })}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineMonitoring;
